export default __webpack_public_path__ + "static/media/browser-js.0ac2a52a.png";